@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_082_905_185)
public val Res.string.subscription_change_seats: StringResource by lazy {
      StringResource("string:subscription_change_seats", "subscription_change_seats", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351001, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500365, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322384, 69),
      ))
    }

@delegate:ResourceContentHash(491_722_101)
public val Res.string.subscription_current_plan: StringResource by lazy {
      StringResource("string:subscription_current_plan", "subscription_current_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351063, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500459, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322454, 49),
      ))
    }

@delegate:ResourceContentHash(-93_607_016)
public val Res.string.subscription_ends_on: StringResource by lazy {
      StringResource("string:subscription_ends_on", "subscription_ends_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351113, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500529, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322504, 68),
      ))
    }

@delegate:ResourceContentHash(656_431_468)
public val Res.string.subscription_manage: StringResource by lazy {
      StringResource("string:subscription_manage", "subscription_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351182, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500638, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322573, 55),
      ))
    }

@delegate:ResourceContentHash(114_096_834)
public val Res.string.subscription_never_expires: StringResource by lazy {
      StringResource("string:subscription_never_expires", "subscription_never_expires", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351242, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500714, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322629, 54),
      ))
    }

@delegate:ResourceContentHash(-877_755_988)
public val Res.string.subscription_none_desc: StringResource by lazy {
      StringResource("string:subscription_none_desc", "subscription_none_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351293, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500781, 246),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322684, 142),
      ))
    }

@delegate:ResourceContentHash(118_016_554)
public val Res.string.subscription_owner_note: StringResource by lazy {
      StringResource("string:subscription_owner_note", "subscription_owner_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351456, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501028, 255),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322827, 151),
      ))
    }

@delegate:ResourceContentHash(-2_008_749_802)
public val Res.string.subscription_renews_on: StringResource by lazy {
      StringResource("string:subscription_renews_on", "subscription_renews_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351636, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501284, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322979, 50),
      ))
    }

@delegate:ResourceContentHash(-60_985_398)
public val Res.string.subscription_restore_done: StringResource by lazy {
      StringResource("string:subscription_restore_done", "subscription_restore_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351691, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501351, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323030, 73),
      ))
    }

@delegate:ResourceContentHash(34_807_396)
public val Res.string.subscription_sandbox: StringResource by lazy {
      StringResource("string:subscription_sandbox", "subscription_sandbox", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351773, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501445, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323104, 48),
      ))
    }

@delegate:ResourceContentHash(-251_366_648)
public val Res.string.subscription_seats_used: StringResource by lazy {
      StringResource("string:subscription_seats_used", "subscription_seats_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351822, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501514, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323153, 75),
      ))
    }

@delegate:ResourceContentHash(-1_763_767_062)
public val Res.string.subscription_store_app_store: StringResource by lazy {
      StringResource("string:subscription_store_app_store", "subscription_store_app_store", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351894, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501602, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323229, 68),
      ))
    }

@delegate:ResourceContentHash(1_895_769_429)
public val Res.string.subscription_store_play: StringResource by lazy {
      StringResource("string:subscription_store_play", "subscription_store_play", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 351959, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501675, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323298, 59),
      ))
    }

@delegate:ResourceContentHash(1_593_747_538)
public val Res.string.subscription_store_promotional: StringResource by lazy {
      StringResource("string:subscription_store_promotional", "subscription_store_promotional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352019, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501747, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323358, 66),
      ))
    }

@delegate:ResourceContentHash(-1_856_022_747)
public val Res.string.subscription_store_web: StringResource by lazy {
      StringResource("string:subscription_store_web", "subscription_store_web", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352090, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501814, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323425, 54),
      ))
    }

@delegate:ResourceContentHash(1_212_552_044)
public val Res.string.subscription_title: StringResource by lazy {
      StringResource("string:subscription_title", "subscription_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352149, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501885, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323480, 54),
      ))
    }

@delegate:ResourceContentHash(951_555_158)
public val Res.string.subscription_trial_desc: StringResource by lazy {
      StringResource("string:subscription_trial_desc", "subscription_trial_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352200, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 501952, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323535, 111),
      ))
    }

@delegate:ResourceContentHash(-260_742_138)
public val Res.string.subscription_trial_not_started: StringResource by lazy {
      StringResource("string:subscription_trial_not_started", "subscription_trial_not_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352304, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502092, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323647, 126),
      ))
    }

@delegate:ResourceContentHash(-1_921_903_807)
public val Res.string.subscription_upgrade: StringResource by lazy {
      StringResource("string:subscription_upgrade", "subscription_upgrade", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352431, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502295, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323774, 48),
      ))
    }

@delegate:ResourceContentHash(-581_356_827)
public val Res.string.swap_candidate_available: StringResource by lazy {
      StringResource("string:swap_candidate_available", "swap_candidate_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352476, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502360, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323823, 44),
      ))
    }

@delegate:ResourceContentHash(988_943_292)
public val Res.string.swap_candidate_no_answer: StringResource by lazy {
      StringResource("string:swap_candidate_no_answer", "swap_candidate_no_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352521, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502417, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323868, 44),
      ))
    }

@delegate:ResourceContentHash(963_710_762)
public val Res.string.swap_candidate_unavailable: StringResource by lazy {
      StringResource("string:swap_candidate_unavailable", "swap_candidate_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352574, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502490, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323913, 50),
      ))
    }

@delegate:ResourceContentHash(1_650_632_860)
public val Res.string.swap_candidate_working: StringResource by lazy {
      StringResource("string:swap_candidate_working", "swap_candidate_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352625, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502553, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323964, 54),
      ))
    }

@delegate:ResourceContentHash(1_286_364_598)
public val Res.string.swap_candidates_none: StringResource by lazy {
      StringResource("string:swap_candidates_none", "swap_candidates_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352680, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502624, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324019, 96),
      ))
    }

@delegate:ResourceContentHash(-980_813_249)
public val Res.string.swap_candidates_role: StringResource by lazy {
      StringResource("string:swap_candidates_role", "swap_candidates_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352781, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502777, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324116, 68),
      ))
    }

@delegate:ResourceContentHash(-1_758_427_256)
public val Res.string.swap_note_label: StringResource by lazy {
      StringResource("string:swap_note_label", "swap_note_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352854, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502862, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324185, 43),
      ))
    }

@delegate:ResourceContentHash(-1_211_348_407)
public val Res.string.swap_note_placeholder: StringResource by lazy {
      StringResource("string:swap_note_placeholder", "swap_note_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352914, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 502950, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324229, 85),
      ))
    }

@delegate:ResourceContentHash(387_961_367)
public val Res.string.swap_note_value: StringResource by lazy {
      StringResource("string:swap_note_value", "swap_note_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 352992, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503060, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324315, 39),
      ))
    }

@delegate:ResourceContentHash(-1_231_815_231)
public val Res.string.swap_status_available: StringResource by lazy {
      StringResource("string:swap_status_available", "swap_status_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353036, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503116, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324355, 53),
      ))
    }

@delegate:ResourceContentHash(1_606_424_017)
public val Res.string.swap_status_rejected: StringResource by lazy {
      StringResource("string:swap_status_rejected", "swap_status_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353082, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503166, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324409, 40),
      ))
    }

@delegate:ResourceContentHash(-1_345_825_874)
public val Res.string.swap_status_requested_by_owner: StringResource by lazy {
      StringResource("string:swap_status_requested_by_owner", "swap_status_requested_by_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353123, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503219, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324450, 66),
      ))
    }

@delegate:ResourceContentHash(1_250_923_780)
public val Res.string.swap_status_taken_pending: StringResource by lazy {
      StringResource("string:swap_status_taken_pending", "swap_status_taken_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353190, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503306, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324517, 69),
      ))
    }

@delegate:ResourceContentHash(546_119_739)
public val Res.string.switch_view: StringResource by lazy {
      StringResource("string:switch_view", "switch_view", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353268, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503404, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324587, 35),
      ))
    }

@delegate:ResourceContentHash(-1_330_789_047)
public val Res.string.team_at_work_since: StringResource by lazy {
      StringResource("string:team_at_work_since", "team_at_work_since", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353304, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503460, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324623, 54),
      ))
    }

@delegate:ResourceContentHash(1_089_382_518)
public val Res.string.team_group_manager: StringResource by lazy {
      StringResource("string:team_group_manager", "team_group_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353687, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503999, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325006, 54),
      ))
    }

@delegate:ResourceContentHash(2_097_453_261)
public val Res.string.team_group_manager_info: StringResource by lazy {
      StringResource("string:team_group_manager_info", "team_group_manager_info", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353355, 211),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503523, 307),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324678, 207),
      ))
    }

@delegate:ResourceContentHash(-795_636_121)
public val Res.string.team_group_manager_open_groups: StringResource by lazy {
      StringResource("string:team_group_manager_open_groups", "team_group_manager_open_groups", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353567, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503831, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324886, 66),
      ))
    }

@delegate:ResourceContentHash(-341_662_354)
public val Res.string.team_group_manager_title: StringResource by lazy {
      StringResource("string:team_group_manager_title", "team_group_manager_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353634, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 503930, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324953, 52),
      ))
    }

@delegate:ResourceContentHash(-1_104_704_996)
public val Res.string.team_guests_hint: StringResource by lazy {
      StringResource("string:team_guests_hint", "team_guests_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353746, 212),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504074, 340),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325061, 204),
      ))
    }

@delegate:ResourceContentHash(-966_753_022)
public val Res.string.team_guests_title: StringResource by lazy {
      StringResource("string:team_guests_title", "team_guests_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 353959, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504415, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325266, 49),
      ))
    }

@delegate:ResourceContentHash(-728_614_113)
public val Res.string.team_inactive: StringResource by lazy {
      StringResource("string:team_inactive", "team_inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354037, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504489, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325316, 33),
      ))
    }

@delegate:ResourceContentHash(-852_876_650)
public val Res.string.team_invite_already_registered: StringResource by lazy {
      StringResource("string:team_invite_already_registered", "team_invite_already_registered", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354075, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504539, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325350, 142),
      ))
    }

@delegate:ResourceContentHash(407_021_053)
public val Res.string.team_invite_prompt_action: StringResource by lazy {
      StringResource("string:team_invite_prompt_action", "team_invite_prompt_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354202, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504758, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325493, 53),
      ))
    }

@delegate:ResourceContentHash(303_901_245)
public val Res.string.team_invite_prompt_dismiss: StringResource by lazy {
      StringResource("string:team_invite_prompt_dismiss", "team_invite_prompt_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354260, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504836, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325547, 42),
      ))
    }

@delegate:ResourceContentHash(783_517_477)
public val Res.string.team_invite_prompt_text: StringResource by lazy {
      StringResource("string:team_invite_prompt_text", "team_invite_prompt_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354303, 335),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 504895, 535),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325590, 315),
      ))
    }

@delegate:ResourceContentHash(1_538_465)
public val Res.string.team_invite_prompt_title: StringResource by lazy {
      StringResource("string:team_invite_prompt_title", "team_invite_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354639, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505431, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325906, 68),
      ))
    }

@delegate:ResourceContentHash(-1_540_584_814)
public val Res.string.team_last_owner: StringResource by lazy {
      StringResource("string:team_last_owner", "team_last_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354712, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505540, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 325975, 71),
      ))
    }

@delegate:ResourceContentHash(970_871_930)
public val Res.string.team_next_shift: StringResource by lazy {
      StringResource("string:team_next_shift", "team_next_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354796, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505660, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326047, 55),
      ))
    }

@delegate:ResourceContentHash(-1_463_182_968)
public val Res.string.team_no_employees: StringResource by lazy {
      StringResource("string:team_no_employees", "team_no_employees", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354860, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505736, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326103, 53),
      ))
    }

@delegate:ResourceContentHash(-604_389_971)
public val Res.string.team_no_scheduled_shifts: StringResource by lazy {
      StringResource("string:team_no_scheduled_shifts", "team_no_scheduled_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354926, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505822, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326157, 60),
      ))
    }

@delegate:ResourceContentHash(-1_676_954_946)
public val Res.string.template_delete: StringResource by lazy {
      StringResource("string:template_delete", "template_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355051, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505999, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326278, 43),
      ))
    }

@delegate:ResourceContentHash(302_706_193)
public val Res.string.template_delete_confirm: StringResource by lazy {
      StringResource("string:template_delete_confirm", "template_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 354991, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 505915, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326218, 59),
      ))
    }

@delegate:ResourceContentHash(197_816_983)
public val Res.string.template_edit: StringResource by lazy {
      StringResource("string:template_edit", "template_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355095, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506063, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326322, 41),
      ))
    }

@delegate:ResourceContentHash(1_788_978_616)
public val Res.string.template_name: StringResource by lazy {
      StringResource("string:template_name", "template_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355204, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506228, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326415, 41),
      ))
    }

@delegate:ResourceContentHash(2_121_904_727)
public val Res.string.template_name_hint: StringResource by lazy {
      StringResource("string:template_name_hint", "template_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355137, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506129, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326364, 50),
      ))
    }

@delegate:ResourceContentHash(-735_039_418)
public val Res.string.template_new: StringResource by lazy {
      StringResource("string:template_new", "template_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355246, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506286, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326457, 36),
      ))
    }

@delegate:ResourceContentHash(-1_364_746_633)
public val Res.string.template_shift_count: StringResource by lazy {
      StringResource("string:template_shift_count", "template_shift_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355283, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506339, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326494, 44),
      ))
    }

@delegate:ResourceContentHash(-1_341_863_484)
public val Res.string.templates_define_days: StringResource by lazy {
      StringResource("string:templates_define_days", "templates_define_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355328, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506392, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326539, 69),
      ))
    }

@delegate:ResourceContentHash(-598_344_299)
public val Res.string.templates_empty: StringResource by lazy {
      StringResource("string:templates_empty", "templates_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355414, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506502, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326609, 47),
      ))
    }

@delegate:ResourceContentHash(1_301_360_236)
public val Res.string.templates_no_slots: StringResource by lazy {
      StringResource("string:templates_no_slots", "templates_no_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355462, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506570, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326657, 82),
      ))
    }

@delegate:ResourceContentHash(-1_951_870_785)
public val Res.string.templates_preferred_shifts: StringResource by lazy {
      StringResource("string:templates_preferred_shifts", "templates_preferred_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355557, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506701, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326740, 58),
      ))
    }

@delegate:ResourceContentHash(-825_320_200)
public val Res.string.templates_title: StringResource by lazy {
      StringResource("string:templates_title", "templates_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355616, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506768, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326799, 43),
      ))
    }

@delegate:ResourceContentHash(1_468_772_668)
public val Res.string.time_format_invalid: StringResource by lazy {
      StringResource("string:time_format_invalid", "time_format_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355664, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506828, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326843, 55),
      ))
    }

@delegate:ResourceContentHash(-729_374_466)
public val Res.string.time_same_start_end: StringResource by lazy {
      StringResource("string:time_same_start_end", "time_same_start_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355752, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 506952, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326899, 79),
      ))
    }

@delegate:ResourceContentHash(23_773_046)
public val Res.string.timeline_action_added: StringResource by lazy {
      StringResource("string:timeline_action_added", "timeline_action_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355840, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507072, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 326979, 53),
      ))
    }

@delegate:ResourceContentHash(-1_292_401_943)
public val Res.string.timeline_action_changed: StringResource by lazy {
      StringResource("string:timeline_action_changed", "timeline_action_changed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355894, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507130, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327033, 55),
      ))
    }

@delegate:ResourceContentHash(1_156_625_435)
public val Res.string.timeline_action_moved: StringResource by lazy {
      StringResource("string:timeline_action_moved", "timeline_action_moved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 355954, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507194, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327089, 53),
      ))
    }

@delegate:ResourceContentHash(-660_717_640)
public val Res.string.timeline_action_removed: StringResource by lazy {
      StringResource("string:timeline_action_removed", "timeline_action_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356016, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507264, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327143, 55),
      ))
    }

@delegate:ResourceContentHash(-180_790_072)
public val Res.string.timeline_add: StringResource by lazy {
      StringResource("string:timeline_add", "timeline_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356167, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507459, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327290, 24),
      ))
    }

@delegate:ResourceContentHash(-1_136_045_866)
public val Res.string.timeline_add_title: StringResource by lazy {
      StringResource("string:timeline_add_title", "timeline_add_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356076, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507332, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327199, 54),
      ))
    }

@delegate:ResourceContentHash(130_598_732)
public val Res.string.timeline_add_to: StringResource by lazy {
      StringResource("string:timeline_add_to", "timeline_add_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356127, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507411, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327254, 35),
      ))
    }

@delegate:ResourceContentHash(-2_115_040_270)
public val Res.string.timeline_audit_by: StringResource by lazy {
      StringResource("string:timeline_audit_by", "timeline_audit_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356196, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507496, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327315, 49),
      ))
    }

@delegate:ResourceContentHash(438_845_599)
public val Res.string.timeline_audit_dates: StringResource by lazy {
      StringResource("string:timeline_audit_dates", "timeline_audit_dates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356246, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507546, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327365, 48),
      ))
    }

@delegate:ResourceContentHash(-1_372_037_386)
public val Res.string.timeline_audit_title: StringResource by lazy {
      StringResource("string:timeline_audit_title", "timeline_audit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356295, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507595, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327414, 48),
      ))
    }

@delegate:ResourceContentHash(-1_928_104_008)
public val Res.string.timeline_current: StringResource by lazy {
      StringResource("string:timeline_current", "timeline_current", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356344, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507656, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327463, 28),
      ))
    }

@delegate:ResourceContentHash(1_951_155_391)
public val Res.string.timeline_drag_hint: StringResource by lazy {
      StringResource("string:timeline_drag_hint", "timeline_drag_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356381, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507697, 258),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327492, 150),
      ))
    }

@delegate:ResourceContentHash(1_325_454_051)
public val Res.string.timeline_edit_title: StringResource by lazy {
      StringResource("string:timeline_edit_title", "timeline_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356552, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 507956, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327643, 51),
      ))
    }

@delegate:ResourceContentHash(-719_273_308)
public val Res.string.timeline_empty_lane: StringResource by lazy {
      StringResource("string:timeline_empty_lane", "timeline_empty_lane", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356596, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508020, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327695, 55),
      ))
    }

@delegate:ResourceContentHash(1_362_308_589)
public val Res.string.timeline_entry_description: StringResource by lazy {
      StringResource("string:timeline_entry_description", "timeline_entry_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356652, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508100, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327751, 58),
      ))
    }

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.timeline_field_day: StringResource by lazy {
      StringResource("string:timeline_field_day", "timeline_field_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356711, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508159, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327810, 30),
      ))
    }

@delegate:ResourceContentHash(870_480_274)
public val Res.string.timeline_field_end_day: StringResource by lazy {
      StringResource("string:timeline_field_end_day", "timeline_field_end_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356746, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508198, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327841, 62),
      ))
    }

@delegate:ResourceContentHash(-1_082_341_487)
public val Res.string.timeline_field_exam_day: StringResource by lazy {
      StringResource("string:timeline_field_exam_day", "timeline_field_exam_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356813, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508289, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327904, 67),
      ))
    }

@delegate:ResourceContentHash(-1_907_865_506)
public val Res.string.timeline_field_from: StringResource by lazy {
      StringResource("string:timeline_field_from", "timeline_field_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356889, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508389, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327972, 43),
      ))
    }

@delegate:ResourceContentHash(-1_533_332_991)
public val Res.string.timeline_field_fte: StringResource by lazy {
      StringResource("string:timeline_field_fte", "timeline_field_fte", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 356937, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508429, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328016, 74),
      ))
    }

@delegate:ResourceContentHash(-2_079_759_765)
public val Res.string.timeline_field_hire_day: StringResource by lazy {
      StringResource("string:timeline_field_hire_day", "timeline_field_hire_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357008, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508524, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328091, 63),
      ))
    }

@delegate:ResourceContentHash(1_813_328_211)
public val Res.string.timeline_field_hours: StringResource by lazy {
      StringResource("string:timeline_field_hours", "timeline_field_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357080, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508612, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328155, 80),
      ))
    }

@delegate:ResourceContentHash(-1_132_248_417)
public val Res.string.timeline_field_kind: StringResource by lazy {
      StringResource("string:timeline_field_kind", "timeline_field_kind", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357189, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508773, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328236, 35),
      ))
    }

@delegate:ResourceContentHash(1_246_880_154)
public val Res.string.timeline_field_note: StringResource by lazy {
      StringResource("string:timeline_field_note", "timeline_field_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357233, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508825, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328272, 35),
      ))
    }

@delegate:ResourceContentHash(-1_595_122_998)
public val Res.string.timeline_field_rate: StringResource by lazy {
      StringResource("string:timeline_field_rate", "timeline_field_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357273, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508873, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328308, 55),
      ))
    }

@delegate:ResourceContentHash(-2_044_476_002)
public val Res.string.timeline_field_relief: StringResource by lazy {
      StringResource("string:timeline_field_relief", "timeline_field_relief", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357337, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 508965, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328364, 37),
      ))
    }

@delegate:ResourceContentHash(234_863_193)
public val Res.string.timeline_field_salary: StringResource by lazy {
      StringResource("string:timeline_field_salary", "timeline_field_salary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357375, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509011, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328402, 61),
      ))
    }

@delegate:ResourceContentHash(1_596_014_825)
public val Res.string.timeline_field_training_day: StringResource by lazy {
      StringResource("string:timeline_field_training_day", "timeline_field_training_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357441, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509097, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328464, 63),
      ))
    }

@delegate:ResourceContentHash(1_474_509_526)
public val Res.string.timeline_field_until: StringResource by lazy {
      StringResource("string:timeline_field_until", "timeline_field_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357501, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509177, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328528, 52),
      ))
    }

@delegate:ResourceContentHash(1_723_177_529)
public val Res.string.timeline_field_valid_until: StringResource by lazy {
      StringResource("string:timeline_field_valid_until", "timeline_field_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357558, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509254, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328581, 50),
      ))
    }

@delegate:ResourceContentHash(1_166_656_336)
public val Res.string.timeline_from: StringResource by lazy {
      StringResource("string:timeline_from", "timeline_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357697, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509421, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328728, 33),
      ))
    }

@delegate:ResourceContentHash(1_234_656_834)
public val Res.string.timeline_from_start: StringResource by lazy {
      StringResource("string:timeline_from_start", "timeline_from_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357605, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509317, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328632, 47),
      ))
    }

@delegate:ResourceContentHash(1_975_403_400)
public val Res.string.timeline_from_until: StringResource by lazy {
      StringResource("string:timeline_from_until", "timeline_from_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357649, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509373, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328680, 47),
      ))
    }

@delegate:ResourceContentHash(62_728_681)
public val Res.string.timeline_fte_hint: StringResource by lazy {
      StringResource("string:timeline_fte_hint", "timeline_fte_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357731, 141),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509455, 221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328762, 145),
      ))
    }

@delegate:ResourceContentHash(340_396_396)
public val Res.string.timeline_hide_rejected: StringResource by lazy {
      StringResource("string:timeline_hide_rejected", "timeline_hide_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357873, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509677, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328908, 50),
      ))
    }

@delegate:ResourceContentHash(-1_049_507_833)
public val Res.string.timeline_hours_value: StringResource by lazy {
      StringResource("string:timeline_hours_value", "timeline_hours_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 357924, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 509752, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328959, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString42Resources(map: MutableMap<String, StringResource>) {
  map.put("subscription_change_seats", Res.string.subscription_change_seats)
  map.put("subscription_current_plan", Res.string.subscription_current_plan)
  map.put("subscription_ends_on", Res.string.subscription_ends_on)
  map.put("subscription_manage", Res.string.subscription_manage)
  map.put("subscription_never_expires", Res.string.subscription_never_expires)
  map.put("subscription_none_desc", Res.string.subscription_none_desc)
  map.put("subscription_owner_note", Res.string.subscription_owner_note)
  map.put("subscription_renews_on", Res.string.subscription_renews_on)
  map.put("subscription_restore_done", Res.string.subscription_restore_done)
  map.put("subscription_sandbox", Res.string.subscription_sandbox)
  map.put("subscription_seats_used", Res.string.subscription_seats_used)
  map.put("subscription_store_app_store", Res.string.subscription_store_app_store)
  map.put("subscription_store_play", Res.string.subscription_store_play)
  map.put("subscription_store_promotional", Res.string.subscription_store_promotional)
  map.put("subscription_store_web", Res.string.subscription_store_web)
  map.put("subscription_title", Res.string.subscription_title)
  map.put("subscription_trial_desc", Res.string.subscription_trial_desc)
  map.put("subscription_trial_not_started", Res.string.subscription_trial_not_started)
  map.put("subscription_upgrade", Res.string.subscription_upgrade)
  map.put("swap_candidate_available", Res.string.swap_candidate_available)
  map.put("swap_candidate_no_answer", Res.string.swap_candidate_no_answer)
  map.put("swap_candidate_unavailable", Res.string.swap_candidate_unavailable)
  map.put("swap_candidate_working", Res.string.swap_candidate_working)
  map.put("swap_candidates_none", Res.string.swap_candidates_none)
  map.put("swap_candidates_role", Res.string.swap_candidates_role)
  map.put("swap_note_label", Res.string.swap_note_label)
  map.put("swap_note_placeholder", Res.string.swap_note_placeholder)
  map.put("swap_note_value", Res.string.swap_note_value)
  map.put("swap_status_available", Res.string.swap_status_available)
  map.put("swap_status_rejected", Res.string.swap_status_rejected)
  map.put("swap_status_requested_by_owner", Res.string.swap_status_requested_by_owner)
  map.put("swap_status_taken_pending", Res.string.swap_status_taken_pending)
  map.put("switch_view", Res.string.switch_view)
  map.put("team_at_work_since", Res.string.team_at_work_since)
  map.put("team_group_manager", Res.string.team_group_manager)
  map.put("team_group_manager_info", Res.string.team_group_manager_info)
  map.put("team_group_manager_open_groups", Res.string.team_group_manager_open_groups)
  map.put("team_group_manager_title", Res.string.team_group_manager_title)
  map.put("team_guests_hint", Res.string.team_guests_hint)
  map.put("team_guests_title", Res.string.team_guests_title)
  map.put("team_inactive", Res.string.team_inactive)
  map.put("team_invite_already_registered", Res.string.team_invite_already_registered)
  map.put("team_invite_prompt_action", Res.string.team_invite_prompt_action)
  map.put("team_invite_prompt_dismiss", Res.string.team_invite_prompt_dismiss)
  map.put("team_invite_prompt_text", Res.string.team_invite_prompt_text)
  map.put("team_invite_prompt_title", Res.string.team_invite_prompt_title)
  map.put("team_last_owner", Res.string.team_last_owner)
  map.put("team_next_shift", Res.string.team_next_shift)
  map.put("team_no_employees", Res.string.team_no_employees)
  map.put("team_no_scheduled_shifts", Res.string.team_no_scheduled_shifts)
  map.put("template_delete", Res.string.template_delete)
  map.put("template_delete_confirm", Res.string.template_delete_confirm)
  map.put("template_edit", Res.string.template_edit)
  map.put("template_name", Res.string.template_name)
  map.put("template_name_hint", Res.string.template_name_hint)
  map.put("template_new", Res.string.template_new)
  map.put("template_shift_count", Res.string.template_shift_count)
  map.put("templates_define_days", Res.string.templates_define_days)
  map.put("templates_empty", Res.string.templates_empty)
  map.put("templates_no_slots", Res.string.templates_no_slots)
  map.put("templates_preferred_shifts", Res.string.templates_preferred_shifts)
  map.put("templates_title", Res.string.templates_title)
  map.put("time_format_invalid", Res.string.time_format_invalid)
  map.put("time_same_start_end", Res.string.time_same_start_end)
  map.put("timeline_action_added", Res.string.timeline_action_added)
  map.put("timeline_action_changed", Res.string.timeline_action_changed)
  map.put("timeline_action_moved", Res.string.timeline_action_moved)
  map.put("timeline_action_removed", Res.string.timeline_action_removed)
  map.put("timeline_add", Res.string.timeline_add)
  map.put("timeline_add_title", Res.string.timeline_add_title)
  map.put("timeline_add_to", Res.string.timeline_add_to)
  map.put("timeline_audit_by", Res.string.timeline_audit_by)
  map.put("timeline_audit_dates", Res.string.timeline_audit_dates)
  map.put("timeline_audit_title", Res.string.timeline_audit_title)
  map.put("timeline_current", Res.string.timeline_current)
  map.put("timeline_drag_hint", Res.string.timeline_drag_hint)
  map.put("timeline_edit_title", Res.string.timeline_edit_title)
  map.put("timeline_empty_lane", Res.string.timeline_empty_lane)
  map.put("timeline_entry_description", Res.string.timeline_entry_description)
  map.put("timeline_field_day", Res.string.timeline_field_day)
  map.put("timeline_field_end_day", Res.string.timeline_field_end_day)
  map.put("timeline_field_exam_day", Res.string.timeline_field_exam_day)
  map.put("timeline_field_from", Res.string.timeline_field_from)
  map.put("timeline_field_fte", Res.string.timeline_field_fte)
  map.put("timeline_field_hire_day", Res.string.timeline_field_hire_day)
  map.put("timeline_field_hours", Res.string.timeline_field_hours)
  map.put("timeline_field_kind", Res.string.timeline_field_kind)
  map.put("timeline_field_note", Res.string.timeline_field_note)
  map.put("timeline_field_rate", Res.string.timeline_field_rate)
  map.put("timeline_field_relief", Res.string.timeline_field_relief)
  map.put("timeline_field_salary", Res.string.timeline_field_salary)
  map.put("timeline_field_training_day", Res.string.timeline_field_training_day)
  map.put("timeline_field_until", Res.string.timeline_field_until)
  map.put("timeline_field_valid_until", Res.string.timeline_field_valid_until)
  map.put("timeline_from", Res.string.timeline_from)
  map.put("timeline_from_start", Res.string.timeline_from_start)
  map.put("timeline_from_until", Res.string.timeline_from_until)
  map.put("timeline_fte_hint", Res.string.timeline_fte_hint)
  map.put("timeline_hide_rejected", Res.string.timeline_hide_rejected)
  map.put("timeline_hours_value", Res.string.timeline_hours_value)
}
